// extracted by mini-css-extract-plugin
export default {"link":"BA5MtC","image":"aiDuIH","root":"ZAhvUK"};